import React from 'react'
import { Box, Typography, Chip, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { SkuInfo } from '../../types'
import { formatExpirationDate } from '../../../../utils/dateHelper'
import { ProductOrigin } from '../../../../interfaces/Producto/ProductOrigins'

interface SkuItemProps {
  sku: SkuInfo
  onDelete?: (sku: string) => void
  disabled?: boolean
  productOrigins: ProductOrigin[] | undefined
  getBackgroundStyle: (
    expirationDate: string | undefined,
    skuProductOrigin: number
  ) => React.CSSProperties
  getTextColor: (
    expirationDate: string | undefined,
    skuProductOrigin: number
  ) => string
}

export const SkuItem: React.FC<SkuItemProps> = ({
  sku,
  onDelete,
  disabled = false,
  productOrigins,
  getBackgroundStyle,
  getTextColor
}) => {
  const skuProductOriginDays =
    productOrigins?.find((el) => el.productOriginId === sku.productOriginId)
      ?.expirationDays || 0

  const expirationDate = sku.batch?.expirationDate || undefined

  const loteChipStyle: React.CSSProperties = {
    ...getBackgroundStyle(expirationDate, skuProductOriginDays),
    color: getTextColor(expirationDate, skuProductOriginDays),
    fontWeight: 600,
    height: 22,
    border: 'none'
  }

  const veniceChipStyle: React.CSSProperties = {
    ...getBackgroundStyle(expirationDate, skuProductOriginDays),
    color: getTextColor(expirationDate, skuProductOriginDays),
    fontWeight: 600,
    height: 22
  }

  return (
    <Box
      style={{
        background: '#fff',
        borderRadius: 12,
        padding: '12px 16px',
        marginBottom: 12,
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
      }}
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: sku.batch?.batchNumber || sku.batch?.expirationDate ? 6 : 0
        }}
      >
        <Box style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Typography
            variant='body2'
            style={{ fontWeight: 700, color: '#1d4ed8', minWidth: 28 }}
          >
            {sku.checkedQty}x
          </Typography>
          <Box>
            {sku.sku && sku.ean13 && sku.sku !== sku.ean13 ? (
              <>
                <Typography variant='body2' style={{ fontWeight: 700, lineHeight: 1.3 }}>
                  <span style={{ color: '#6b7280', fontWeight: 500 }}>SKU: </span>
                  {sku.sku}
                </Typography>
                <Typography variant='body2' style={{ fontWeight: 700, lineHeight: 1.3 }}>
                  <span style={{ color: '#6b7280', fontWeight: 500 }}>EAN: </span>
                  {sku.ean13}
                </Typography>
              </>
            ) : (
              <Typography variant='body2' style={{ fontWeight: 700 }}>
                {sku.ean13 || sku.sku}
              </Typography>
            )}
          </Box>
        </Box>
        {onDelete && (
          <IconButton
            size='small'
            onClick={() => onDelete(sku.sku)}
            disabled={disabled}
            style={{ color: '#999' }}
          >
            <CloseIcon fontSize='small' />
          </IconButton>
        )}
      </Box>

      
        <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {sku.brandName && (
            <Chip
              label={`Marca: ${sku.brandName}`}
              size='small'
              style={loteChipStyle}
            />
          )}
          {sku.batch?.batchNumber && (
            <Chip
              label={`Lote: ${sku.batch.batchNumber}`}
              size='small'
              style={loteChipStyle}
            />
          )}
          {sku.batch?.expirationDate && (
            <Chip
              label={`Vence: ${formatExpirationDate(sku.batch.expirationDate, 'dd-MM-yyyy')}`}
              size='small'
              style={veniceChipStyle}
            />
          )}
        </Box>
    
    </Box>
  )
}
